import Constants from 'expo-constants';

/**
 * OTA update counter, bumped by `scripts/increment-update-version.js` before
 * each `eas update`. Combined with the semver `version` from app.json, it
 * gives a unique build+update stamp (e.g. `1.0.3-14`) so we can tell exactly
 * which JS bundle a device is running.
 *
 * The `update` npm script passes this file's path to the bump script — if the
 * constant moves, that path has to move with it or every publish ships a
 * stale counter.
 */
const UPDATE_VERSION = 6;

/** Build + update stamp, e.g. `1.0.0-1`. Falls back on web, where `expoConfig` can be absent. */
export const APP_VERSION = `${Constants.expoConfig?.version ?? '1.0.0'}-${UPDATE_VERSION}`;
